const jobCategories = [
  "Air-Con, Heating and Cooling",
  "Bodywork and Dent Repairs",
  "Brakes",
  "Clutch and Gearbox Repairs",
  "Diagnostics and Inspections",
  "Electrical and Lights",
  "Engine",
  "Exhaust and Emissions",
  "Help Me - I'm Not Sure",
  "Interior, Audio",
  "Mobile Mechanics and Services",
  "Security, Locking and Keys",
  "Service and Maintenance",
  "Suspension and Steering",
  "Tyres, Wheels and Alignment",
  "Windows, Windscreens and Mirrors",
];

export default jobCategories;
